var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.94,
    height: 34.944,
    viewBox: "0 0 34.94 34.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home",
    d: "M34,15.2l0,0L19.745.942a3.216,3.216,0,0,0-4.55,0L.948,15.188.934,15.2a3.216,3.216,0,0,0,2.141,5.481q.049,0,.1,0h.568v10.49a3.769,3.769,0,0,0,3.765,3.765h5.577a1.024,1.024,0,0,0,1.024-1.024V25.7a1.72,1.72,0,0,1,1.718-1.718h3.289A1.72,1.72,0,0,1,20.833,25.7V33.92a1.024,1.024,0,0,0,1.024,1.024h5.577A3.769,3.769,0,0,0,31.2,31.179V20.689h.527A3.217,3.217,0,0,0,34,15.2Zm0,0",
    transform: "translate(0 0.001)",
    fill: "#df9426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelectedIcon);
export default __webpack_public_path__ + "static/media/homeSelected_icon.bd859f9470ccb67b8ed3b15058cd201a.svg";
export { ForwardRef as ReactComponent };